<template>
  <div>
    <!-- <b-row>
      <b-col class="mb-2">
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          size="sm"
          variant="outline-primary"
          class="refresh-button d-flex align-items-center justify-content-center"
          :disabled="loading"
          @click="refreshAgingReport()"
        >
          <feather-icon
            icon="RefreshCwIcon"
            class="mr-50 refresh-icon"
          />
          <span class="align-middle refresh-span">Refreshed</span>
          <time-ago
            class="timeAgo"
            :datetime="refreshedDate"
            refresh
            locale="en"
            :long="longString"
            :style="{ color: 'black' }"
          />
        </b-button>
      </b-col>
    </b-row> -->
    <b-card no-body>
      <div>
        <!-- table -->
        <b-overlay
          id="overlay-background"
          variant="light"
          opacity="0.30"
          blur="10px"
          rounded="sm"
        >
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="rows"
            :fields="fields"
            show-empty
            sticky-header="100vh"
          >
            <template #empty>
              <TableDataFetching
                :rows="rows"
                :data-loading="dataLoading"
              />
            </template>
            <template #cell(created_at)="data">
              <div>
                {{ __dateTimeFormatter(data.item.created_at) }}
              </div>
            </template>
            <template #cell(url)="data">
              <a
                :href="data.item.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ data.item.url }}
              </a>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="12"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item @click="onClickShowMerchant(data.item.average)">
                  <feather-icon icon="EyeIcon" />
                  View Merchant
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row cols="12">
              <b-col
                class="d-flex align-items-center justify-content-sm-start"
                md="3"
              >
                <label class="width-75">Per page</label>
                <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block width-125"
                />
              </b-col>
              <!-- Pagination -->
              <b-col
                class="d-flex align-items-center justify-content-sm-end"
                md="9"
              >
                <span class="text-muted pagination-text mt-1 mt-md-0 mr-1">
                  Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries
                </span>
                <b-pagination
                  v-model="page"
                  :per-page="perPage"
                  :total-rows="meta.total || 0"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </div>
    </b-card>
    <aging-merchant ref="agingMerchant" />
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  // BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// import { TimeAgo } from 'vue2-timeago'
import 'vue2-timeago/dist/vue2-timeago.css'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import ErrorMessage from '@core/mixins/ErrorMessage'

const reportRepository = RepositoryFactory.get('report')

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BPagination,
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    vSelect,
    BDropdown,
    BDropdownItem,
    // TimeAgo,
    // BButton,
  },
  mixins: [ErrorMessage],
  data() {
    return {
      refreshedDate: new Date(),
      longString: true,
      rows: [],
      fields: [
        {
          key: 'job_id', label: 'Report Reference', sortable: true, thClass: 'text-left', tdClass: 'text-left',
        },
        {
          key: 'created_at', label: 'Generated At', sortable: true, thClass: 'text-left', tdClass: 'text-left', thStyle: { width: '200px' },
        },
        {
          key: 'url', label: 'URL', sortable: true, thClass: 'text-left', tdClass: 'text-left',
        },
      ],
      perPage: 20,
      pageOptions: [10, 20, 50, 100, 200],
      page: 1,
      meta: {},
      dataLoading: false,
      loading: false,
      items: [],
      json_fields: {
        Average: {
          field: 'average',
          callback: value => `"${value}"`,
        },
        'Merchant Count': {
          field: 'count',
          callback: value => `"${value}"`,
        },
        'Color Code': {
          field: 'color_code',
          callback: value => `"${value}"`,
        },
      },
    }
  },
  watch: {
    page() {
      this.fetchReportDownloads()
    },
    perPage() {
      this.fetchReportDownloads()
    },
  },
  mounted() {
    this.fetchReportDownloads()
  },
  methods: {
    async fetchReportDownloads() {
      this.dataLoading = true
      try {
        const { data } = (await reportRepository.fetchReportDownloads(this.filterQuery, this.page, this.perPage))
        this.rows = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    // eslint-disable-next-line consistent-return
    async fetchReportDownloadsNoPagination() {
      try {
        const { data } = (await reportRepository.fetchReportDownloadsNoPagination()).data
        return data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    // refreshAgingReport() {
    //   this.loading = true
    //   this.refreshedDate = new Date()
    //   this.fetchAgingReportData().then(() => {
    //     this.loading = false
    //   })
    // },
    onClickShowMerchant(averageGroup) {
      this.$router.push({ name: 'aging-merchant', query: { average: averageGroup } })
    },
    onClickRefresh() {
      this.fetchReportDownloads()
    },
  },
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

.color-dot-container {
  display: flex;
  align-items: center;
}

.color-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.timeAgo {
  margin-left: 5px;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.refresh-button {
  float: right;
}

.refresh-icon {
  color: black !important;
}

.refresh-span {
  color: black !important;
  font-size: 13px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-bottom: 1px;
}
</style>
